var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-address-form" },
    [
      _c(
        "div",
        { staticClass: "delivery-address-form__form-group" },
        [
          _vm.LOGGED_IN
            ? _c("delivery-address-name", {
                ref: "addressName",
                staticClass: "delivery-address-form__address",
                attrs: {
                  addresses: _vm.addresses,
                  "selected-address-id": _vm.selectedAddressId,
                  "is-save-address": _vm.isSaveAddress,
                  "is-show-save-address": _vm.isShowSaveAddress
                },
                on: { new: _vm.resetAddress, set: _vm.setAddress },
                model: {
                  value: _vm.addressName,
                  callback: function($$v) {
                    _vm.addressName = $$v
                  },
                  expression: "addressName"
                }
              })
            : _vm._e(),
          _c("ui-street-suggest", {
            ref: "street",
            staticClass: "delivery-address-form__street",
            attrs: { "city-id": _vm.cityId },
            model: {
              value: _vm.street,
              callback: function($$v) {
                _vm.street = $$v
              },
              expression: "street"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "delivery-address-form__form-group delivery-address-form__form-group_grid"
        },
        [
          _c("ui-house-suggest", {
            ref: "house",
            staticClass: "delivery-address-form__house",
            attrs: {
              "street-id": _vm.form.streetId,
              label: "Дом *",
              placeholder: "Дом, стр./кор."
            },
            model: {
              value: _vm.house,
              callback: function($$v) {
                _vm.house = $$v
              },
              expression: "house"
            }
          }),
          _c("ui-input", {
            ref: "entrance",
            staticClass: "delivery-address-form__entrance",
            attrs: {
              label: "Подъезд",
              placeholder: "Подъезд",
              validate: "address_detail",
              clearable: ""
            },
            model: {
              value: _vm.form.entrance,
              callback: function($$v) {
                _vm.$set(_vm.form, "entrance", $$v)
              },
              expression: "form.entrance"
            }
          }),
          _c("ui-input", {
            ref: "floor",
            staticClass: "delivery-address-form__floor",
            attrs: {
              label: "Этаж",
              placeholder: "Этаж",
              validate: "floor",
              clearable: ""
            },
            model: {
              value: _vm.form.floor,
              callback: function($$v) {
                _vm.$set(_vm.form, "floor", $$v)
              },
              expression: "form.floor"
            }
          }),
          _c("ui-input", {
            ref: "apartment",
            staticClass: "delivery-address-form__apartment",
            attrs: {
              label: "Кв./Офис",
              placeholder: "Кв./Офис",
              validate: "address_detail",
              clearable: ""
            },
            model: {
              value: _vm.form.apartment,
              callback: function($$v) {
                _vm.$set(_vm.form, "apartment", $$v)
              },
              expression: "form.apartment"
            }
          })
        ],
        1
      ),
      _c("delivery-date", {
        staticClass: "delivery-address-form__date",
        model: {
          value: _vm.form.intervalTimeId,
          callback: function($$v) {
            _vm.$set(_vm.form, "intervalTimeId", $$v)
          },
          expression: "form.intervalTimeId"
        }
      }),
      _c("ui-textarea", {
        staticClass: "delivery-address-form__comment",
        attrs: {
          height: "128",
          label: "Комментарий",
          placeholder: "Комментарий к заказу"
        },
        model: {
          value: _vm.comment,
          callback: function($$v) {
            _vm.comment = $$v
          },
          expression: "comment"
        }
      }),
      _c("div", { staticClass: "delivery-address-form__delivery-price" }, [
        _c("b", [_vm._v("Стоимость доставки:")]),
        _vm._v(" " + _vm._s(_vm._f("price")(_vm.deliveryPrice)) + " ₽\n  ")
      ]),
      _c(
        "div",
        { staticClass: "delivery-address-form__footer" },
        [
          _vm.isShowSaveAddress
            ? _c("ui-checkbox", {
                staticClass: "delivery-address-form__save-address",
                attrs: { label: "Сохранить адрес в Адреса доставки" },
                model: {
                  value: _vm.isSaveAddress,
                  callback: function($$v) {
                    _vm.isSaveAddress = $$v
                  },
                  expression: "isSaveAddress"
                }
              })
            : _vm._e(),
          _c("ui-button", {
            staticClass: "delivery-address-form__save-btn",
            attrs: { text: "Сохранить" },
            on: { click: _vm.onSave }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }